import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { MyClientLookupModel } from 'core/models/my-client-lookup.model';

@Injectable({
    providedIn: 'root',
})
export class ApiMyclientsLookup extends ApiListDataService<MyClientLookupModel, any> {
    constructor(http: HttpClient) {
        super(http, '/Client/MyClients/Lookup/');
    }
}
